import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { ReactComponent as AlertIcon } from './resources/icon_alert.svg';
import './ErrorBlock.css';
import './LyriaPay.css';


const FormField = ({name, value, onChange = null, label, errors}) => {
    const { t } = useTranslation();
    const isNotValid = errors && errors.length !== 0;

    return (
        <div className={`${(isNotValid) ? 'wz-lyriapay-formblock-error' : 'wz-lyriapay-formblock'}`}>
            <label htmlFor={name}>{t(label)}</label>
            <input
                name={name}
                value={value}
                onChange={e => {
                    if (onChange !== null) onChange(e.target.value);
                }}
                aria-invalid={isNotValid}
            />
            {isNotValid && (
                <div className="wz-lyriapay-error-block">
                    {errors.map((error, index) => (
                        <div
                            key={index}
                            className="wz-lyriapay-errorlabel"
                        >
                            <div className="wz-lyriapay-errorlabel-icon">
                                <AlertIcon />
                            </div>
                            <div className="wz-lyriapay-errorlabel-content">
                                {t([`${label}_error_${error.code}`, `error_${error.code}`, 'error_form'])}
                            </div>
                        </div>
                    ))}
                </div>
            )
            }
        </div>
    );
};

FormField.propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.string,
    onChange: PropTypes.func,
    label: PropTypes.string.isRequired,
    errors: PropTypes.arrayOf(PropTypes.object),
};

export default FormField;
